module.exports = __webpack_public_path__ + "media/img/landing_image_desktop-e83d4fdc.png";